import React from 'react';
import AppBar from "../../../Components/header/index";
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
// import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
// import Profile from "../../../images/profile.png"
// import {useRedirect} from "react-admin";

const useStyles = makeStyles(theme => ({
    "@global": {
      body: {
        backgroundColor: "#F7F7F7",
      }
    },
    Avatar:{
        height:"35px"
    }
}));

export default function Schedule({handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest}) {
    const classes = useStyles();
    // const redirect=useRedirect();

  var  card = [
      {item : "Consultation Fee",price : "Rs 700", },
      {item : "Processing Charges", price : "Rs 70" },
      {item : "GST", price : "Rs 138.60" },
      // {item : "Total", price : "Rs 908.60" },

    ]
    var  card1 = [
      {item : "Total", price : "Rs 908.60" },

    ]
 
  console.log("card",card)
      // const handleClick1=()=>{
      //   return(
      //     redirect('/mentorprofile/:id')
      //   )
      // }

    return (
        <div className={classes.div}>
            <AppBar/>
            <div style={{paddingLeft:"4%",paddingRight:"4%"}}>
              <form onSubmit={handleSubmit} noValidate>
                <Paper style={{padding:"15px",boxShadow:"none",}}>
                <Typography  variant="subtitle2" style={{textAlign:"center",fontSize:"24px",paddingBottom:"15px"}}>Make Payment</Typography>
                <Paper style={{width:"300px",margin:"auto",background:"#FEFBFB",height:"260px",boxShadow:"0px 0px 7px rgba(0, 0, 0, 0.32)"}}>
                <Typography varinat="body1" style={{marginTop:"10px",textAlign:"center",fontWeight:"bold",paddingBottom:"10px"}}>Billing Details</Typography>
                <Divider light style={{marginTop:"8px",border:"0.5px gray solid"}}/>
                {card.map(card=>(
                <Grid container  >
                <Grid item xs={8} style={{paddingLeft:"30px"}}>
                <Typography variant="subtitle2" style={{marginTop:"20px",textAlign:"left",}}>
                {card.item}
                 </Typography>
                </Grid>
                <Grid item xs={4} style={{paddingLeft:"30px"}}>
                <Typography variant="subtitle2" style={{marginTop:"20px",textAlign:"left",}}>
                {card.price}
                 </Typography>
                </Grid>
                </Grid>
                ))}
                <div>
                {card1.map(card1=>(
                <Grid container style={{borderTop:"1px gray solid",marginTop:"15px"}}>
                   <Grid item xs={8} style={{paddingLeft:"30px"}}>
                <Typography variant="subtitle2" style={{marginTop:"10px",textAlign:"left",}}>
               {card1.item}
                 </Typography>
                </Grid>
                <Grid item xs={4} style={{paddingLeft:"30px"}}>
                <Typography variant="subtitle2" style={{marginTop:"10px",textAlign:"left",}}>
                {card1.price}

                 </Typography>
                </Grid>
                </Grid>
                ))}
                </div>
                 </Paper>

                <Grid container  style={{marginTop:"8vh"}}>
                <Grid item xs={6}>
                    <Button  style={{background:"#D14002",color:"white",borderRadius:"5px",padding:"5px  ",width:"100px"}}
                     onClick={() => { }}>
                        Cancel
                    </Button>
                </Grid>
                <Grid item xs={6} >
                <Button type="submit" style={{background:"#0288D1",color:"white",borderRadius:"5px",float:"right",padding:"5px  ",width:"150px",textTransform:"none"}}>
                Make Payment
                </Button>
                </Grid>
                
                </Grid>
               </Paper>
               </form>
            </div>
         </div>
    );
}
